<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Inconsistências"
    >
        <template v-if="data">

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        disabled
                        label="Data do atendimento"
                        v-model="data.dataAtendimento"
                    />
                </rkm-col>

                <rkm-col cols="9">
                    <rkm-form-input
                        disabled
                        label="Paciente"
                        v-model="data.pacienteNome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Unidade"
                        v-model="data.unidadeNomeFantasia"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Profissional"
                        v-model="data.usuarioNome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-table
                :fields="fields"
                :items="data.inconsistencias"
                hide-filters
                hide-pagination
                sort-by="text"
            />
        </template>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        fields: [{ key: 'text', label: 'Descrição', sortable: true }],
        data: null,
    }),
    methods: {
        open(data) {

            data.inconsistencias = data.inconsistencias.map(i => ({ text: i.descricao }))
            this.data = data

            this.$refs.Modal.show()
        },
    },
}
</script>